import { NgModule } from '@angular/core';
import { SuiviSaisieComponent } from './suivi-saisie.component';
import { SharedModule } from '../shared/shared.module';
import { SaisieModule } from '../saisie/saisie.module';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule, MatPaginatorIntl } from '@angular/material/paginator';
import { MatInputModule } from '@angular/material/input';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorIntlBis } from './matPaginatorIntlBisClass';
import { SuiviGeneralPermanenteComponent } from './suivi-general-permanente/suivi-general-permanente.component';
import { SuiviDetailPermanenteComponent } from './suivi-detail-permanente/suivi-detail-permanente.component';

@NgModule({
  declarations: [SuiviSaisieComponent, SuiviGeneralPermanenteComponent, SuiviDetailPermanenteComponent],
  imports: [
    SharedModule,
    SaisieModule,
    MatTableModule,
    MatPaginatorModule,
    MatInputModule,
    MatSortModule
  ],
  providers: [{ provide: MatPaginatorIntl, useClass: MatPaginatorIntlBis }],
})
export class SuiviSaisieModule { }
